<template>
  <fts-modal
    contentClass="confirmation__body"
    footerClass="confirmation__footer"
    class="fts-confirmation-modal confirmation--error"
    :header="false"
    width="350px"
    @close="close"
    v-if="showDialog">
    <!-- body -->
    <template #body>
      <!-- close -->
      <fts-btn icon text class="confirmation-close" @click="close">
        <font-awesome-icon :icon="['fas', 'times']" />
      </fts-btn>
      <!-- icon -->
      <font-awesome-icon :icon="['far', 'trash-alt']" class="confirmation-icon" />
      <!-- title -->
      <div class="confirmation-title">Are you sure?</div>
      <!-- desc -->
      <div class="confirmation-desc">
        <span>Do you really want to delete&nbsp;</span>
        <span class="module-wrapper">
          <fts-moji :emoji="moduleData.emoji" :size="16" class="module-emoji" v-if="moduleData.emoji" />
          <span class="module-name">{{moduleData.name}}</span>
        </span>
        <span>?</span>
      </div>
      <!-- form -->
      <div class="confirmation-mt">
        <div class="confirmation-label">Type "delete" to confirm</div>
        <input 
          type="text" 
          class="fts-form-control 
          confirmation-form-control" 
          v-model="formData.secretKey"
          @keydown.enter="done"
          ref="secretKeyInput">
        <div class="confirmation-form-err-msg" v-if="$v.formData.secretKey.$error">secret key "delete" not match.</div>
      </div>
    </template>
    <!-- footer -->
    <template #footer>
      <fts-btn outline box-shadow-none text-transform-init class="confirmation-action" @click="close">
        Cancel
      </fts-btn>
      <fts-btn color="danger" box-shadow-none text-transform-init class="confirmation-action" @click="done">
        Delete
      </fts-btn>
    </template>
  </fts-modal>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
import { required } from "vuelidate/lib/validators";

import FTSModal from "../elements/FTSModal";
import FTSBtn from "../elements/FTSBtn";
import FTSMoji from "../elements/FTSMoji";

export default {
  components: {
    "fts-modal": FTSModal,
    "fts-btn": FTSBtn,
    "fts-moji": FTSMoji,
  },
  data: () => ({
    formData: {},
    moduleData: null,
    showDialog: false,
    resolve: null
  }),
  validations() {
    let formData = {};
    formData.secretKey = {
      required,
      validator: (res) => res === 'delete'
    }
    return {formData}
  },
  methods: {
    show(moduleData) {
      this.moduleData = _.cloneDeep(moduleData)

      return new Promise(resolve => {
        this.resolve = resolve
        this.showDialog = true

        this.$nextTick(() => {
          this.$refs.secretKeyInput.focus();
        });
      })
    },
    done() {
      this.$v.formData.$touch();
      if (this.$v.formData.$invalid) {
        this.onFocusSecretKeyInput();
      } else {
        const data = _.cloneDeep(this.moduleData)
        this.reset()
        this.resolve && this.resolve(data)
      }
    },
    close() {
      this.reset()
      this.resolve && this.resolve(null)
    },
    reset() {
      this.$v.$reset();
      this.formData = {}
      this.moduleData = null
      this.showDialog = false
    },
    onFocusSecretKeyInput() {
      this.$refs.secretKeyInput.focus();
    },
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-confirmation-modal {
  &.confirmation--error {
    .confirmation__body {
      border-top: 5px solid $dangerColor;
    }
    .confirmation-icon {
      color: $dangerColor;
    }
  }
  .confirmation__body {
    position: relative;
    padding: 3rem 3rem 2rem;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    text-align: center;
    .confirmation-mt {
      margin-top: 3rem;
    }
    .confirmation-close {
      position: absolute;
      top: .375rem;
      right: .375rem;
      font-size: 1rem;
    }
    .confirmation-icon {
      margin-bottom: 2rem;
      font-size: 3rem;
    } 
    .confirmation-title {
      font-size: 1.5rem;
      font-weight: 500;
      line-height: 1.5;
    }
    .confirmation-desc {
      color: $grayLightColor;
      line-height: 1.5;

      min-width: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      .module-wrapper {
        display: flex;align-items: center;min-width: 0;
        white-space: nowrap;
        .module-emoji {
          margin-right: .375rem;
        }
        .module-name {
          @include text-overflow-ellipsis;
        }
      }
    }
    .confirmation-label {
      font-size: .875rem;
      color: $grayLightColor;
    }
    .confirmation-form-control {
      font-size: .875rem;
      border-radius: .25rem;
      text-align: inherit;
    }
    .confirmation-form-err-msg {
      margin-top: .375rem;
      font-size: .875rem;
      color: $dangerColor;
    } 
    .confirmation-label + .confirmation-form-control {
      margin-top: .375rem;
    }
  }
  .confirmation__footer {
    padding: 1rem 1rem 2rem;
    text-align: center;
    .confirmation-action {
      padding: 1.15rem;
    }
    .confirmation-action + .confirmation-action {
      margin-left: .375rem;
    }
  }
}
</style>